<template>
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2731_14079)">
            <path d="M14.6693 1.33203L10.0026 14.6654L7.33594 8.66536L1.33594 5.9987L14.6693 1.33203Z" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M14.6693 1.33203L7.33594 8.66536" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
            <clipPath id="clip0_2731_14079">
            <rect width="16" height="16" fill="white"/>
            </clipPath>
            </defs>
    </svg>
</template>